import React from "react";

const RlNavItemSeparator: React.FC = () => (
  <div className="rl-nav__item-separator" />
);

export default RlNavItemSeparator;
